import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Divider, Typography } from "@mui/material";
import { Checkbox } from "../../../Checkbox";
import { convertPxToRem } from "../../../../util-functions";
const StyledHeader = styled("div")({
    margin: `${convertPxToRem(10)} ${convertPxToRem(16)}`,
});
const StyledDivider = styled(Divider)(({ theme }) => ({
    marginTop: convertPxToRem(10),
    borderColor: theme.palette.grey04.main,
}));
const StyledGroupContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    marginTop: convertPxToRem(10),
    marginLeft: convertPxToRem(28),
    "> div": {
        marginBottom: convertPxToRem(10),
        marginTop: convertPxToRem(10),
    },
});
export const NestedCheckboxes = ({ checkboxes, header, selectableHeader = false, testId, }) => {
    const { key: headerKey, label: headerLabel, onChange: headerOnChange, testId: headerTestId, value: headerValue, } = header;
    const nestedCheckboxes = [...checkboxes];
    const numberOfCheckedCheckboxes = nestedCheckboxes.filter((checkbox) => checkbox.checked).length;
    return (_jsxs("div", Object.assign({ "data-testid": testId }, { children: [_jsxs(StyledHeader, Object.assign({ "data-testid": testId && `nestedCheckboxesHeader-${testId}` }, { children: [selectableHeader ? (_jsx(Checkbox, { label: headerLabel, checked: numberOfCheckedCheckboxes === checkboxes.length, useDashIcon: numberOfCheckedCheckboxes > 0 &&
                            numberOfCheckedCheckboxes < nestedCheckboxes.length, onChange: () => headerOnChange === null || headerOnChange === void 0 ? void 0 : headerOnChange(headerKey), value: headerValue, testId: headerTestId }, headerKey)) : (_jsx(Typography, Object.assign({ variant: "largeText" }, { children: headerLabel }), headerKey)), _jsx(StyledDivider, {})] })), _jsx(StyledGroupContainer, Object.assign({ "data-testid": testId && `nestedCheckboxesGroup-${testId}` }, { children: checkboxes.map((checkbox) => {
                    const { key, label, checked, onChange, value, testId: checkboxTestId, } = checkbox;
                    return (_jsx(Checkbox, { label: label, checked: checked, value: value, onChange: () => onChange(key, !checked), testId: checkboxTestId }, key));
                }) }))] })));
};
